import { render, staticRenderFns } from "./ManterSolicitacaoAcessoView.vue?vue&type=template&id=f189e7f0"
import script from "./ManterSolicitacaoAcessoView.vue?vue&type=script&lang=js"
export * from "./ManterSolicitacaoAcessoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports